import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Combokeys from 'combokeys'
import { Bttn, Effects } from 'dbrain-web-ui-lib'
import uuidv4 from 'uuid/v4'
import TextCategorizationFragment from './fragment'
import { isTouchDevice, clearHightlightedText } from '../../../../utils/common'
import config from '../../../../config'
import AssignmentResult from '../../assignmentResult'

import './style'

const getIndexOfCategory = (buttons, category) => {
	const buttonsHasGroups = buttons[0].group !== undefined
	const categoryNormal = buttonsHasGroups ? category.split('-')[0] : category
	const elements = buttonsHasGroups ? [...new Set(buttons.map(b => b.group))] : buttons.map(b => b.value)

	return (elements.indexOf(categoryNormal) + 1)
}

class TextCategorization extends Component {
	constructor(props) {
		super(props)
		this.state = {
			active: null,
			rangeList: [],
			selectionId: null,
			activeCategory: null,
			marksError: false,
		}
		this.combokeys = new Combokeys(document.documentElement)
	}

	componentWillMount() {
		this.attachComboKeys(this.props)
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.onMouseDown.bind(this))
		document.addEventListener('mouseup', this.onMouseUp.bind(this))
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.task.id !== this.props.task.id) {
			this.setState({
				rangeList: [],
				active: null,
				selectionId: null,
				activeCategory: null,
			})
		}

		if (
			nextProps.task.id === this.props.task.id &&
			nextProps.isNeedToShowTaskResults
		) {
			this.combokeys.reset()
		}

		if (
			nextProps.task.id !== this.props.task.id &&
			!nextProps.isNeedToShowTaskResults
		) {
			this.attachComboKeys(nextProps)
		}
	}

	componentWillUnmount() {
		this.combokeys.detach()
	}

	onMouseUp(e) {
		const { activeCategory, selectionId } = this.state
		const { rangeCount } = window.getSelection()

		if (
			activeCategory &&
			selectionId &&
			rangeCount
		) {
			this.updateRangeList()
		}
	}

	onMouseDown(e) {
		const { activeCategory } = this.state
		const isTarget = e.target === this.textItem || e.target === this.textContainer

		if (
			activeCategory &&
			isTarget
		) {
			this.generateNewRange()
		}
	}

	onFragmentRemove(id) {
		this.setState((prev) => {
			const rangeList = Object.assign([], prev.rangeList)

			rangeList.forEach((r, num) => {
				if (r.id === id) {
					rangeList.splice(num, 1)
				}
			})

			return {
				rangeList,
			}
		})
	}

	attachComboKeys(props) {
		const { task } = props
		const { values } = task.payload

		values.forEach((value, i) => {
			const idx = i + 1

			this.combokeys.bind(String(idx), () => {
				if (this.state.active !== null) return

				this.setState({ active: i })

				setTimeout(() => {
					this.setState({ active: null })
					this.handleChooseCategory(values[i].value, null, task.type)
				}, 100)
			})
		})
	}

	generateNewRange() {
		const { activeCategory: category } = this.state
		const { values } = this.props.task.payload

		const selectionId = uuidv4()
		const selectionIdx = getIndexOfCategory(values, category)
		const hasGroups = values[0].group !== undefined
		const value = hasGroups ? category.split('-')[1] : category

		const rangeItem = {
			selectionIdx,
			value,
			category,
			id: selectionId,
		}

		this.setState(prev => ({
			selectionId,
			rangeList: [...prev.rangeList, rangeItem],
			mouseDown: true,
		}))
	}

	updateRangeList() {
		const { selectionId } = this.state
		const { rangeCount } = window.getSelection()

		if (!rangeCount) return

		const { startOffset: start, endOffset: finish } = window.getSelection().getRangeAt(0)
		const range = start > finish ? { finish: start, start: finish } : { start, finish }

		this.setState((prev) => {
			const rangeList = Object.assign([], prev.rangeList)

			rangeList.forEach((r, num) => {
				if (r.id === selectionId) {
					if (
						(range.start !== range.finish) &&
						(range.start >= 0 && range.finish >= 0)
					) {
						r.range = range
					} else {
						rangeList.splice(num, 1)
					}
				}
			})

			rangeList.forEach((r, num) => {
				let counter = 0

				rangeList.forEach((localr) => {
					if (
						r.range.start === localr.range.start &&
						r.range.finish === localr.range.finish
					) {
						if (counter === 0) {
							counter += 1
						} else {
							rangeList.splice(num, 1)
						}
					}
				})
			})

			return {
				rangeList,
				mouseDown: false,
				selectionId: null,
			}
		})

		clearHightlightedText()
	}

	generateHighlitedRanges() {
		const { rangeList } = this.state
		const { isNeedToShowTaskResults, task, rightScoreThreshold } = this.props
		const { text } = this.props.task.payload

		if (!rangeList.length && !isNeedToShowTaskResults) {
			return ''
		}

		const ranges = []

		const existedRanges = rangeList.filter(r => r.range && r.range.start >= 0 && r.range.finish >= 0)
		const parentClientRect = this.textContainer.getBoundingClientRect()

		existedRanges.forEach((item) => {
			const rItem = (
				<TextCategorizationFragment
					key={item.id}
					id={item.id}
					range={item.range}
					text={text}
					disabled={isNeedToShowTaskResults}
					index={item.selectionIdx}
					parent={parentClientRect}
					onRemove={this.onFragmentRemove.bind(this)}
				/>
			)

			ranges.push(rItem)
		})


		const { comparedResult } = this.props

		if (isNeedToShowTaskResults && comparedResult.score < rightScoreThreshold[task.type]) {
			const { result } = comparedResult
			const resultKeys = Object.keys(result)

			resultKeys.forEach((resKey, number) => {
				const resultLabels = result[resKey]

				resultLabels.forEach((resLabel) => {
					const key = uuidv4()

					const item = (
						<TextCategorizationFragment
							key={key}
							id={key}
							range={{ start: resLabel[0], finish: resLabel[1] }}
							text={text}
							classList={['right-result']}
							itemNumber={number + 1}
							index="right-result"
							parent={parentClientRect}
							onRemove={this.onFragmentRemove.bind(this)}
						/>
					)

					ranges.push(item)
				})
			})
		}

		return ranges
	}

	generateInput() {
		const { activeCategory } = this.state
		const { task } = this.props
		const { payload } = task
		const index = activeCategory ? getIndexOfCategory(payload.values, activeCategory) : null
		const selectionClassName = index ? `text-value-main__selection-${index}` : ''

		if (
			(task.type === 'textcategorization' || payload.type === 'textcategorization') &&
			task.payload.text
		) {
			return (
				<div className="image image-textcategorization col-4 col-sm-4 col-xs-2">
					<div className="text-value">
						<div
							className="text-value-wrapper"
							ref={(c) => { this.textContainer = c }}
						>
							<p
								className={`text-value-main ${selectionClassName}`}
								tabIndex="-1"
								ref={(c) => { this.textItem = c }}
							>
								{task.payload.text}
							</p>

							{this.generateHighlitedRanges()}
						</div>
					</div>
				</div>
			)
		}

		return ''
	}

	handleChooseCategory(newValue) {
		const { activeCategory: oldCategory } = this.state
		let activeCategory = null

		if (newValue !== oldCategory) {
			activeCategory = newValue
		}

		clearHightlightedText()

		this.setState({ activeCategory })
	}

	generateButtons() {
		const { task, isNeedToShowTaskResults } = this.props
		const { activeGroup, activeCategory, rangeList } = this.state
		let labels = task.payload.values
		const existedCategories = [...new Set(rangeList.map(r => r.category))]
		const isGrouped = labels[0].group !== undefined

		if (isGrouped) {
			const uniqueGroupItems = [...new Set(labels.map(label => label.group))]

			labels = []
			uniqueGroupItems.forEach((group) => {
				const tmp = []

				task.payload.values.forEach((val) => {
					if (val.group === group) {
						tmp.push(val)
					}
				})

				labels.push(tmp)
			})

			return labels.map((group, groupNum) => {
				const activeGroupClassName = group[0].group === activeGroup ? 'grouped__active' : ''

				return (
					<div
						className={`buttons marks grouped ${activeGroupClassName}`}
						key={group[0].group}
					>
						<p className="buttons-title text-4-type-1">{group[0].group}</p>
						{
							group.map((g, labelNum) => {
								const currentCategory = `${g.group}-${g.value}`
								const existsClassName = existedCategories.includes(currentCategory) ? 'exists' : ''
								const pressedClassName = activeCategory === currentCategory ? 'pressed' : ''
								const text = isTouchDevice() ? g.text : `${groupNum + 1}.${labelNum + 1}. ${g.text}`

								return (
									<Bttn
										key={currentCategory}
										className={`${existsClassName} ${pressedClassName} rainbow`}
										onClick={(e) => {
											e.preventDefault(); this.handleChooseCategory(currentCategory)
										}}
									>
										{text}
									</Bttn>
								)
							})
						}
					</div>
				)
			})
		}

		return (
			<div className="buttons marks">
				{
					labels.map((item, i) => {
						const existsClassName = existedCategories.includes(item.value) ? 'exists' : ''
						const pressedClassName = activeCategory === item.value ? 'pressed' : ''
						const text = isTouchDevice() ? item.text : `${i + 1}. ${item.text}`

						return (
							<Bttn
								key={item.value}
								disabled={isNeedToShowTaskResults}
								className={`${existsClassName} ${pressedClassName} rainbow`}
								onClick={(e) => { e.preventDefault(); this.handleChooseCategory(item.value) }}
							>
								{text}
							</Bttn>
						)
					})
				}
			</div>
		)
	}

	handleMark(type) {
		const { rangeList } = this.state
		const { task } = this.props
		const payload = {}

		if (
			(type === 'complete' && rangeList.length === 0) ||
			(type === 'noobjects' && rangeList.length !== 0)
		) {
			this.setState({ marksError: true })

			return
		}

		task.payload.values.forEach((item) => {
			payload[item.value] = []
		})

		rangeList.forEach((rangeItem) => {
			const { start, finish } = rangeItem.range
			payload[rangeItem.category].push([start, finish])
		})

		this.props.markTask(payload, rangeList, task.type)
	}

	render() {
		const {
			task,
			markTask,
			testLabel,
			caption,
			currentTaskCaption,
			description,
			fullDescriptionPopup,
			isNeedToShowTaskResults,
			comparedResult,
			rightScoreThreshold,
			nextTask,
		} = this.props
		const labels = task.payload.values

		const buttons = labels.map((item, i) => {
			const idx = i + 1
			const text = isTouchDevice() ? item.text : `${idx}. ${item.text}`
			const className = []

			className.push(item.value === 'other' ? 'btn-border' : 'btn btn-gray')
			className.push(i === this.state.active ? 'active' : '')

			if (isNeedToShowTaskResults) {
				if (comparedResult.result === comparedResult.user && item.value === comparedResult.user) {
					className.push('formitem-success')
				} else {
					className.push(
						item.value === comparedResult.user ? 'formitem-fail' : '',
						item.value === comparedResult.result ? 'formitem-success' : '',
					)
				}
			}

			return (
				<span
					role="button"
					tabIndex="0"
					key={item.value}
					className={className.join(' ')}
					disabled={isNeedToShowTaskResults}
					onClick={() => { this.handleChooseCategory(item.value, null, task.type) }}
					data-testid="taskCompleteButton"
				>
					{text}
				</span>
			)
		})

		const bottomButtons = isNeedToShowTaskResults
			? (
				<div className="buttons taskresult">
					<AssignmentResult isRight={comparedResult.score >= rightScoreThreshold[task.type]} />

					<span
						className="taskresult-next btn"
						role="button"
						tabIndex="0"
						onClick={nextTask}
					>
						Next
					</span>
				</div>
			)
			: (
				<Fragment>
					<div className="buttons">
						<span
							role="button"
							tabIndex="0"
							className="btn btn-gray"
							onClick={() => this.handleMark('complete')}
						>
							Complete
						</span>
						<span
							role="button"
							tabIndex="0"
							className="btn-border"
							onClick={() => this.handleMark('noobjects', {})}
						>
							Not applicable
						</span>
					</div>
				</Fragment>
			)

		return (
			<div className="annotation row">
				<div className="image-wrapper">
					{this.generateInput()}
				</div>

				<div className="actions col-2 col-sm-4 col-xs-2">
					<div className="actions-inner">
						{testLabel}
						<div className="gap-back sm-hidden" />
						{currentTaskCaption}
						{caption}
						{description}
						<div className="gap-back sm-hidden" />
						<div className="buttons-outer">
							<Effects
								transition="shakeShort"
								transitionFinish={() => { this.setState({ marksError: false }) }}
								init={this.state.marksError}
							>
								<div className="buttons marks">
									{this.generateButtons()}
								</div>
							</Effects>

							{bottomButtons}
						</div>
					</div>
				</div>
				{fullDescriptionPopup}
			</div>
		)
	}
}
TextCategorization.defaultProps = {
	testLabel: null,
	caption: null,
	description: null,
	comparedResult: {},
}
TextCategorization.propTypes = {
	task: PropTypes.object.isRequired,
	markTask: PropTypes.func.isRequired,
	testLabel: PropTypes.node,
	caption: PropTypes.node,
	currentTaskCaption: PropTypes.node.isRequired,
	description: PropTypes.node,
	fullDescriptionPopup: PropTypes.node.isRequired,
	isNeedToShowTaskResults: PropTypes.bool.isRequired,
	comparedResult: PropTypes.object,
	nextTask: PropTypes.func.isRequired,
	rightScoreThreshold: PropTypes.object.isRequired,
}

export default TextCategorization
